// mejora-web F4: campos de texto en ES/EN/RU/FR (mismo patrón en todas las páginas nuevas).
import { useTranslation } from 'react-i18next';

export const LANGS = ['es', 'en', 'ru', 'fr'];

export default function CamposIdiomas({ prefijo, etiqueta, form, setForm, multilinea = false, filas = 2, requeridoEs = false, placeholders = {} }) {
  const { t } = useTranslation();
  return (
    <>
      {LANGS.map((l) => {
        const k = `${prefijo}_${l}`;
        const props = {
          value: form[k] || '',
          onChange: (e) => setForm((f) => ({ ...f, [k]: e.target.value })),
          required: requeridoEs && l === 'es',
          placeholder: placeholders[l] || '',
        };
        return (
          <div key={k} className={'modal-campo' + (multilinea ? ' full' : '')}>
            <label>{etiqueta} · {t(`admin.mw.idioma.${l}`)}</label>
            {multilinea ? <textarea rows={filas} {...props} /> : <input type="text" {...props} />}
          </div>
        );
      })}
    </>
  );
}
